import { JSX } from 'solid-js';
import { customElement, noShadowDOM } from 'solid-element';
import {
  UvCameraControlSelector,
  type UvCameraControlSelectorProps,
} from '@trimble/ui-components/solidjs';

// Define web component props that allow undefined for compatibility
interface UvCameraControlSelectorWebProps {
  onCameraSelected:
    | UvCameraControlSelectorProps['onCameraSelected']
    | undefined;
}

export function defineUvCameraControlSelector(): void {
  customElement<UvCameraControlSelectorWebProps>(
    'uv-camera-control-selector',
    {
      onCameraSelected: undefined,
    },
    (props): JSX.Element => {
      noShadowDOM();
      return (
        <UvCameraControlSelector
          onCameraSelected={
            props.onCameraSelected ??
            ((() =>
              undefined) as UvCameraControlSelectorProps['onCameraSelected'])
          }
        />
      );
    }
  );
}

export type { UvCameraControlSelectorWebProps as UvCameraControlSelectorWebComponentProps };
